import demo from  './demo.json';
import oto from  './oto.json';
import ph from  './ph.json';
import th from './th.json'
export default {demo,oto,ph,th};
